import { useEffect } from 'react';
import { DASHBOARD_QUICK_ACTIONS } from '../components/dashboard/dashboardQuickActions';

const isTypingTarget = (target) => {
  if (!target) return false;
  const tag = target.tagName?.toLowerCase();
  if (tag === 'input' || tag === 'textarea' || tag === 'select') return true;
  if (target.isContentEditable) return true;
  return Boolean(target.closest?.('[contenteditable="true"]'));
};

/**
 * Registers F1–F9 shortcuts on the dashboard (capture phase so browser help does not open).
 */
const useDashboardShortcuts = (navigate, enabled = true, actions) => {
  const actionList = actions?.length ? actions : DASHBOARD_QUICK_ACTIONS;

  useEffect(() => {
    if (!enabled || !navigate || !actionList.length) return undefined;

    const handler = (event) => {
      if (isTypingTarget(event.target)) return;

      const action = actionList.find((item) => item.key === event.key);
      if (!action) return;

      event.preventDefault();
      event.stopPropagation();
      navigate(action.path);
    };

    window.addEventListener('keydown', handler, true);
    return () => window.removeEventListener('keydown', handler, true);
  }, [navigate, enabled, actionList]);
};

export default useDashboardShortcuts;
